<div class="form-check d-flex">
  <input class="form-check-input" type="checkbox" [(ngModel)]="isChecked" (change)="checkValue($event)"
    id="sendConfirmationCheckbox">
  <label class="form-check-label" for="sendConfirmationCheckbox">
    <span i18n="@@ShoppingCartCheckoutSendConfirmationCheckboxLabel">Send confirmation E-Mail</span>
    @if (addressString) {
      <span> ({{ addressString }})</span>
    }
  </label>
</div>